import React from 'react';
import { Radio, Tag } from '@useblu/ocean-react';
import { LightningBolt } from '@useblu/ocean-icons-react';

import Actions from '@/components/Actions';
import InternalPage from '@/components/InternalPage';

import * as S from './styles';
import InstallmentsDrawer from './InstallmentsDrawer';
import { PaymentMethods } from '../../types/paymentLinkContextTypes';
import usePaymentMethods from './usePaymentMethods';

const PaymentMethod: React.FC = () => {
  const {
    paymentMethods,
    handleItemClick,
    installmentsType,
    drawerOpen,
    setDrawerOpen,
    handleContinue,
    maxSteps,
  } = usePaymentMethods();

  return (
    <InternalPage
      columns={8}
      title="Como gostaria de pagar?"
      steps={{ currentStep: 1, steps: maxSteps }}
    >
      <S.ListOption>
        {paymentMethods.map(method => (
          <S.Option key={method.id} onClick={() => handleItemClick(method.id)}>
            <S.OptionContent>
              <Radio label={method.label} name="payment-method" />
              {method.fast && (
                <Tag icon={<LightningBolt size={16} />} type="neutral-02">
                  Mais rápido
                </Tag>
              )}
            </S.OptionContent>
            {method.asset && <img src={method.asset} alt={method.label} />}
          </S.Option>
        ))}
      </S.ListOption>
      <Actions submitType="button" nextStep={handleContinue} />
      <InstallmentsDrawer
        open={drawerOpen}
        handleClose={() => setDrawerOpen(false)}
        type={installmentsType as PaymentMethods}
      />
    </InternalPage>
  );
};

export default PaymentMethod;
